import React, { PureComponent } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import { BrowserRouter as Router } from "react-router-dom";
import Navigation from "../navigation/Navigation";
import Header from "../header/Header";
import GameHeader from "../gameheader/GameHeader";
import PolicyDrawer from "../policydrawer/PolicyDrawer";
import GameIndex from "../../routes/gameIndex/GameIndex";
import RoleAssignment from "../../routes/roleassignment/RoleAssignment";
import { Provider } from "mobx-react";
import Store from "../../store";
import { FETCH_URL, CAMS_URL } from "../../constants/ServerLinks";
import { STUDENT_POLL_TIME } from "../../constants/Polling";

export default class Authenticator extends PureComponent {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
    this.world_skey = this.cookies.get("world_skey");
    this.worldId = this.cookies.get("world_id");
    this.role_id = this.cookies.get("role_id");
    this.role_name = this.cookies.get("role_name");
    this.p_id = this.cookies.get("p_id");
    this.token = this.cookies.get("token");
    this.config_number = this.cookies.get("config_number");
    this.country_id = this.cookies.get("country_id");
    this.current_year = this.cookies.get("current_year");

    this.store = this.worldId && new Store({}, this.worldId);

    this.state = { page: "", updateDrawer: true };

    this.polTime = STUDENT_POLL_TIME;
  }

  authenticateRole = () => {
    axios
      .post(this.fetchURL + "/api/v1/roles/authenticate/", {
        world_skey: this.world_skey,
        role_id: this.role_id,
      })
      .then((response) => {
        // console.group("Authenticator:authenticateRole");
        // console.log(response.data);

        if (response.data.success) {
          // console.log("Role Authentication Successful");
          this.store.policies.fetchPolicies().then(() => {
            this.store.articles.fetchArticles().then(() => {
              this.store.tweets.fetchTweets().then(() => {
                this.store.countries.fetchCountries().then(() => {
                  this.store.world.fetchWorld().then(() => {
                    this.store.metrics
                      .fetchMetrics(this.country_id)
                      .then(() => {
                        this.setState({ page: "game" });
                      });
                  });
                });
              });
            });
          });
        } else {
          console.log("Need to login!");

          this.setState({ page: "landing" });
          this.cookies.remove("p_id");
          this.cookies.remove("s_name");
          this.cookies.remove("world_id");
          this.cookies.remove("world_name");
          this.cookies.remove("world_skey");
          this.cookies.remove("config_number");
          this.cookies.remove("role_id");
          this.cookies.remove("role_name");
          this.cookies.remove("country_id");
          this.cookies.remove("country_name");
          this.cookies.remove("current_year");
        }
        // console.groupEnd();
      })
      .catch((error) => {
        this.setState({ page: "landing" });
        console.log(error.response);
      });
  };

  authenticateWorld = (skey) => {
    if (skey) {
      axios
        .post(this.fetchURL + "/api/v1/worlds/authenticate/", {
          world_skey: skey,
        })
        .then((response) => {
          // console.group("Authenticator:authenticateworld");
          // console.log(response.data);

          if (response.data.success) {
            console.log("World Authentication Successful");

            this.setState({ page: "assign" });

            const data = response.data.data;
            this.cookies.set("world_id", data.world_id, { maxAge: 86400 });
          } else {
            this.setState({ page: "landing" });
            this.cookies.remove("p_id");
            this.cookies.remove("s_name");
            this.cookies.remove("world_id");
            this.cookies.remove("world_name");
            this.cookies.remove("world_skey");
            this.cookies.remove("config_number");
            this.cookies.remove("role_id");
            this.cookies.remove("role_name");
            this.cookies.remove("country_id");
            this.cookies.remove("country_name");
            this.cookies.remove("current_year");
          }
          // console.groupEnd();
        })
        .catch((error) => {
          this.setState({ page: "landing" });
          console.log(error.response);
        });
    } else {
      // console.log(this.world_skey)
      axios
        .post(this.fetchURL + "/api/v1/worlds/authenticate/", {
          world_skey: this.world_skey,
        })
        .then((response) => {
          // console.group("Authenticator:authenticateworld");
          // console.log(response.data);

          if (response.data.success) {
            console.log("World Authentication Successful");
            const data = response.data.data;
            this.cookies.set("world_id", data.world_id, { maxAge: 86400 });
            this.cookies.set("world_name", data.world_name, { maxAge: 86400 });

            this.setState({ page: "assign" });
          } else {
            this.setState({ page: "landing" });
            this.cookies.remove("p_id");
            this.cookies.remove("s_name");
            this.cookies.remove("world_id");
            this.cookies.remove("world_name");
            this.cookies.remove("world_skey");
            this.cookies.remove("config_number");
            this.cookies.remove("role_id");
            this.cookies.remove("role_name");
            this.cookies.remove("country_id");
            this.cookies.remove("country_name");
            this.cookies.remove("current_year");
          }
          // console.groupEnd();
        })
        .catch((error) => {
          this.setState({ page: "landing" });
          console.log(error.response);
        });
    }
  };

  authenticateInstructor = (token) => {
    axios
      .get(this.camsURL + "/api/auth/user", {
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        window.location.replace("instructor");
      })
      .catch((error) => {});
  };

  componentDidMount = () => {
    // console.log("role Id: ", this.role_id)
    const skey = window.location.href.split("/")[4];
    const pid = window.location.href.split("/")[5];
    const studentName = window.location.href.split("/")[6];
    const origin = window.location.href.split("/")[7];
    if (origin) {
      this.cookies.set("origin", origin, { maxAge: 86400 });
    } else {
      this.cookies.set("origin", "NOT_CLSG", { maxAge: 86400 });
    }
    if (this.token) {
      this.authenticateInstructor(this.token);
    }
    // console.log("Inside Authenticator, skey is:  " + skey)
    if (this.role_id === undefined) {
      if (
        skey !== undefined &&
        pid !== undefined &&
        studentName !== undefined
      ) {
        this.cookies.set("world_skey", skey, { maxAge: 86400 });
        this.cookies.set("p_id", pid, { maxAge: 86400 });
        this.cookies.set("s_name", decodeURI(studentName), { maxAge: 86400 });
        this.world_skey = skey;
        this.authenticateWorld();
        // this.authenticateWorld(skey);
      } else {
        // console.log("Inside Authenticator, world skey is: ", this.cookies.get('world_skey'))
        this.authenticateWorld();
      }
    } else {
      this.authenticateRole();
    }
  };

  sendToDecisions = () => {
    this.setState(() => ({
      std: new Date().getTime(),
    }));
  };

  onCb = () => {
    this.setState(() => ({
      updateDrawer: true,
    }));
  };

  componentDidUpdate = () => {
    this.setState(() => ({
      updateDrawer: false,
    }));
  };

  render() {
    return (
      <div>
        {this.state.page === "game" ? (
          <Provider {...this.store}>
            <div>
              <Router>
                <GameHeader
                  roleName={this.role_name}
                  updateDrawer={this.state.updateDrawer}
                />
              </Router>

              <Navigation
                roleName={this.role_name}
                polTime={this.polTime}
                cb={this.onCb}
                std={this.state.std}
              />

              {!this.role_name.includes("ATG") && (
                <PolicyDrawer
                  updateDrawer={this.state.updateDrawer}
                  sendToDecisions={this.sendToDecisions}
                />
              )}
            </div>
          </Provider>
        ) : null}
        {this.state.page === "landing" ? (
          <div>
            <Router>
              <Header />
            </Router>
            <GameIndex display="show" />
          </div>
        ) : null}
        {this.state.page === "assign" ? (
          <div>
            <Router>
              <Header />
            </Router>
            <RoleAssignment display="show" />
          </div>
        ) : null}
      </div>
    );
  }
}
